<template>
    <div>
        <el-menu :default-active="activeIndex" @select="handleSelect">
            <el-menu-item index="1" style="margin-left: -30px">
               <Icon type="md-list" size="18" />
                <span slot="title">检查列表</span>
            </el-menu-item>
             <el-menu-item index="2">
               <Icon type="md-settings" size="18" />
                <span slot="title">检查设置</span>
            </el-menu-item>
            <el-menu-item index="3">
                <Icon type="ios-contacts" size="18" />
                <span slot="title">检查对象</span>
            </el-menu-item>
            <el-menu-item index="4">
                <Icon type="ios-contact" size="18" />
                <span slot="title">检查人员</span>
            </el-menu-item>
            <el-menu-item index="5">
                <Icon type="md-list-box" size="18" />
                <span slot="title">检查项目</span>
            </el-menu-item>
            <el-menu-item index="6">
                <Icon type="ios-cloud-circle" size="18" />
                <span slot="title">检查发布</span>
            </el-menu-item>
             <el-menu-item index="7">
                <Icon type="md-document" size="18" />
                <span slot="title">结果统计</span>
            </el-menu-item>
            
            
        </el-menu>
    </div>
</template>
<script>
import {Icon} from 'iview'
export default {
    components: {
      Icon
    },
    props: ['activeIndex'],
    data() {
        return {
            
        }
    },
    created() {
    },
    methods: {

        handleActiveIndex() {
            console.log(this.$route)
        },
        handleSelect(key, keyPath) {
            //console.log(keyPath)
            //this.activeIndex = keyPath[0]
            if (key == '1') {
                var name = 'yunjiancha'

            }
            if (key == '2') {
                var name = 'jianchasetting'

            }
            if (key == '3') {
                var name = 'newjcdx'

            }
            if (key == '4') {
                var name = 'newjcry'

            }
            if (key == '5') {
                var name = 'newitem'
            }
            if (key == '6') {
                var name = 'jianchafabu'

            }
            if (key == '7') {
                var name = 'jianchatognji'

            }
            this.$router.push({
                name: name,
                params: {
                    app_id: this.$route.params.app_id
                }
            })
        },
    }
}
</script>